/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIUnreadEntity
 */
export interface APIUnreadEntity {
    /**
     * 
     * @type {number}
     * @memberof APIUnreadEntity
     */
    count: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof APIUnreadEntity
     */
    items: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the APIUnreadEntity interface.
 */
export function instanceOfAPIUnreadEntity(value: object): value is APIUnreadEntity {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function APIUnreadEntityFromJSON(json: any): APIUnreadEntity {
    return APIUnreadEntityFromJSONTyped(json, false);
}

export function APIUnreadEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUnreadEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'items': json['items'],
    };
}

export function APIUnreadEntityToJSON(value?: APIUnreadEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'items': value['items'],
    };
}

